import Nullstack from 'nullstack';
export default function IconSeparator({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-separator",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "12",
    x2: "3",
    y2: "12.01"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "12",
    x2: "17",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "21",
    y1: "12",
    x2: "21",
    y2: "12.01"
  }), " ");
}